<div class="map_base" [ngClass]="{ active: true }">
  <div *ngIf="searchInProgress" class="loadingMap alert">
    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Search initiated
  </div>
  <!-- <div *ngIf="searchSuccessMessage" class="loadingMap alert pull-right mr-4 d-lg-block">
    <img src="../../assets/images/msgTick.svg" width="30" class="inline-block "
      *ngIf="searchSuccessMessage.propertyExist">
    <img src="../../assets/images/alert-red.svg" width="30" class="inline-block"
      *ngIf="!searchSuccessMessage.propertyExist">
    <b class="inline-block ml-1">
      {{searchSuccessMessage.message}} </b>
  </div> -->
  <!-- <app-view-search *ngIf="mapFacade.getShowMapControls() | async"></app-view-search> -->

  <!-- Map Selection by draw Tool -->
  <!-- <div *ngIf="mapFacade.getShowMapControls() | async">
    <div class="mr-4 search_typebase">
      <div class="inline-block">
        <p class="pull-left mb-0 d-none d-sm-none d-md-block">Search by :</p>
        <button mat-button class="btn" (click)="initDrawing('circle')">
          <img src="../../assets/images/rad.png" class="mr-1">
          <span>Radius</span>
        </button>
        <hr class="d-block d-sm-block d-md-none my-2">
        <button mat-button class="btn" (click)="initDrawing('polygon')">
          <img src="../../assets/images/poly.png" class="mr-1">
          <span>Polygon</span>
        </button>
      </div>
      <br class="d-block d-sm-block d-md-none">
      <button mat-button class="btn reset" *ngIf="drawnShape" (click)="clearDrawing('InitClear')">Clear</button>
    </div>
  </div> -->
  <!-- Map Selection by draw Tool -->

  <!-- <div class="toogleMap" [ngClass]="{'active':showMapOnly}">
    <button mat-flat-button matTooltipPosition="left" (click)="changeMapControls()"
      matTooltip="{{showMapOnly?'Hide Map Controls':'Show Map Controls'}}" aria-label=""> <img *ngIf="!showMapOnly"
        src="../../assets/images/mapSettingsView.png" width="20"> <img *ngIf="showMapOnly"
        src="../../assets/images/mapSettings.png" width="20"> </button>
  </div> -->

  <!-- <app-favorite-widget *ngIf="mapFacade.getShowMapControls() | async"></app-favorite-widget> -->

  <!-- <app-status-bar *ngIf="mapFacade.getShowMapControls() | async"></app-status-bar> -->

  <mat-drawer-container>
    <mat-drawer #drawer mode="side" position="end" [opened]="mobileQuery.matches || activeWorkspaceMode">
      <app-property-list-sheet
        (showOnMap)="showOnMap($event)"
        [drawer]="drawer"
        (drawerArrowStatus)="updateArrowStatus($event)"
      >
      </app-property-list-sheet>
    </mat-drawer>

    <mat-drawer-content>
      <app-view-search class="d-block d-md-none" *ngIf="mapFacade.getShowMapControls() | async"></app-view-search>
      <!-- <div *ngIf="mapFacade.getShowMapControls() | async">
        <div class="mr-4 search_typebase">
          <div class="inline-block">
            <p class="pull-left mb-0 d-none d-sm-none d-md-block">Search by :</p>
            <button mat-button class="btn" (click)="initDrawing('circle')" name="search by radius"
              aria-label="search by radius" tabindex="7">
              <img src="../../assets/images/rad.png" class="mr-1" alt="">
              <span class="d-none d-sm-none d-md-inline-block">Radius</span>
            </button>
            <hr class="d-block d-sm-block d-md-none my-2">
            <button mat-button class="btn" (click)="initDrawing('polygon')" name="search by polygon"
              aria-label="search by polygon" tabindex="7">
              <img src="../../assets/images/poly.png" class="mr-1" alt="">
              <span class="d-none d-sm-none d-md-inline-block">Polygon</span>
            </button>
          </div>
          <br class="d-block d-sm-block d-md-none">
          <button mat-button class="btn reset" *ngIf="drawnShape" (click)="clearDrawing('InitClear')"
            name="clear search">Clear</button>
        </div>
      </div> -->

      <div class="toogleMap" [ngClass]="{ active: showMapOnly }">
        <button
          mat-flat-button
          matTooltipPosition="left"
          (click)="changeMapControls()"
          matTooltip="{{ showMapOnly ? 'Hide Map Controls' : 'Show Map Controls' }}"
          aria-label=""
          name="toggle map controls"
        >
          <img *ngIf="!showMapOnly" src="../../assets/images/mapSettingsView.png" width="20" alt="" />
          <img *ngIf="showMapOnly" src="../../assets/images/mapSettings.png" width="20" alt="" />
        </button>
      </div>

      <!-- <app-favorite-widget class="favorite-widget" *ngIf="mapFacade.getShowMapControls() | async"></app-favorite-widget> -->
      <!-- <app-favorite-widget
        class="favorite-widget"
        *ngIf="companyName != 'homehunt' || (companyName == 'homehunt' && userType != 'agent')"
      ></app-favorite-widget> -->

      <div class="prop_lst_btn">
        <button mat-button (click)="drawer.toggle(); togglePropertyList()" name="toggle property list">
          <div *ngIf="openPropertyListStatus" matTooltip="Hide Property List" matTooltipPosition="left">
            <img src="../../assets/images/backArrow.svg" width="25" class="right-arrow" alt="" />
          </div>
          <div *ngIf="!openPropertyListStatus" matTooltip="Show Property List" matTooltipPosition="left">
            <img width="25" src="../../assets/images/backArrow.svg" alt="" />
          </div>
        </button>
      </div>

      <div id="map"></div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
